import { ActionFunctionArgs } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { isNotDefined } from '@hsp/utilities';

import { userService } from 'services/user.service';
import { IErrorResult, OperationResultType } from 'types/api/common';
import { IPasswordChange } from 'types/api/user';
import { s } from 'utilities/strings';

export const changePasswordAction = (_: QueryClient) => {
  return async ({ request }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const changePasswordRequest: Record<string, string> = {};

    formData.forEach((value, key) => (changePasswordRequest[key] = value as string));

    try {
      const response = await userService.changePassword(changePasswordRequest as unknown as IPasswordChange);

      if (isNotDefined(response)) {
        throw new Error(s('Api.UnknownError'));
      }

      if (response.failure) {
        const keys = Object.keys(response);

        return keys.reduce(
          (previous, current) => {
            previous = {
              ...previous,
              [current]: (response as unknown as Record<string, unknown>)[current],
            };

            return previous;
          },
          {} as Record<string, unknown>
        ) as unknown as IErrorResult;
      }

      return response.dataContainer;
    } catch (e) {
      return {
        message: (e instanceof Error ? e : new Error(e?.toString())).message,
      } as IErrorResult;
      // return { error: e instanceof Error ? e : new Error(e?.toString()) };
    }
  };
};

export type ChangePasswordAction =
  | OperationResultType<Awaited<ReturnType<typeof userService.changePassword>>>
  | IErrorResult;
